// Step configuration for the MSSP signup wizard
// Step 1: Company info  (name, address — Google Maps autocomplete)
// Step 2: Contact info  (first/last name, domain, email, phone)

export const MSSP_SIGNUP_STEPS = [
  {
    key: 'company',
    label: 'Company',
    stepNumber: 1,
    validate: (formData) => {
      const errors = {};
      if (!formData.msspName?.trim()) {
        errors.msspName = 'Company name is required';
      }
      if (!formData.regionId) {
        errors.regionId = 'Region is required';
      }
      if (!formData.country) {
        errors.country = 'Country is required';
      }
      if (!formData.address1?.trim()) {
        errors.address1 = 'Address is required';
      }
      if (!formData.city?.trim()) {
        errors.city = 'City is required';
      }
      if (!formData.state?.trim()) {
        errors.state = 'State is required';
      }
      if (!formData.postalCode?.trim()) {
        errors.postalCode = 'ZIP code is required';
      }
      return { isValid: Object.keys(errors).length === 0, errors };
    }
  },
  {
    key: 'contact',
    label: 'Contact',
    stepNumber: 2,
    validate: (formData) => {
      const errors = {};
      if (!formData.userFirstName?.trim()) {
        errors.userFirstName = 'First name is required';
      }
      if (!formData.userLastName?.trim()) {
        errors.userLastName = 'Last name is required';
      }
      if (!formData.userDomain?.trim()) {
        errors.userDomain = 'Domain is required';
      } else if (
        !/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(
          formData.userDomain.trim()
        )
      ) {
        errors.userDomain = 'Enter a valid domain (e.g. company.com)';
      }
      if (!formData.userEmail?.trim()) {
        errors.userEmail = 'Email is required';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.userEmail)) {
        errors.userEmail = 'Please enter a valid email address';
      }
      if (!formData.userPhoneNumber?.trim()) {
        errors.userPhoneNumber = 'Phone number is required';
      }
      if (!formData.captchaAnswer?.trim()) {
        errors.captchaAnswer = 'Please type the characters shown in the image';
      } else if (formData.captchaAnswer.trim().toUpperCase() !== formData.captchaExpected) {
        errors.captchaAnswer = "Characters don't match — please try again";
      }
      return { isValid: Object.keys(errors).length === 0, errors };
    }
  }
];

// Helpers
export const getStepByKey    = (key) => MSSP_SIGNUP_STEPS.find(s => s.key === key);
export const getNextStep     = (key) => { const i = MSSP_SIGNUP_STEPS.findIndex(s => s.key === key); return MSSP_SIGNUP_STEPS[i + 1] || null; };
export const getPreviousStep = (key) => { const i = MSSP_SIGNUP_STEPS.findIndex(s => s.key === key); return MSSP_SIGNUP_STEPS[i - 1] || null; };
